import React, { useState } from "react";
import { Subscription } from "react-apollo";
import EdgePanel from "components/EdgePanel/EdgePanel";
import SiloLevels from "./SiloLevels";
import SUBSCRIBE_TO_SILO_STATUS from "../graphql/subscriptions/subscribeToSiloStatus";

export const SILOS_PANEL_ID = "silos";

const SiloIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 8.5a5 2 0 0 1 10 0v8a5 2 0 0 1-10 0z" />
    <path d="M7 12q5 1.2 10 0" />
    <path d="M7 15.2q5 1.2 10 0" />
  </svg>
);

const SilosPanel = ({ locations }) => {
  // Estado ao vivo por local, empurrado pelo controller: status + massa estimada ± incerteza.
  // Semeado pelo siloState da query (último estado no cloud) e atualizado pela subscription.
  // Vive aqui (não no SiloLevels) porque a orelha, fora do corpo do painel, também precisa dele.
  const [liveStateById, setLiveStateById] = useState({});
  const stateById = (locations || []).reduce((acc, location) => {
    const state = liveStateById[location.id] || location.siloState;
    return state ? { ...acc, [location.id]: state } : acc;
  }, {});
  const anyRefilling = Object.values(stateById).some((state) => state.status === "refilling");

  return (
    <React.Fragment>
      {/* Sempre montada, mesmo com o painel fechado: o abastecimento começa fora do ciclo de
          carga, então a orelha precisa acender em tempo real sem interação. */}
      <Subscription
        subscription={SUBSCRIBE_TO_SILO_STATUS}
        onSubscriptionData={({ subscriptionData }) => {
          const update = subscriptionData
            && subscriptionData.data
            && subscriptionData.data.subscribeToSiloStatus;
          if (!update) return;
          setLiveStateById((prev) => ({ ...prev, [update.inventoryLocationId]: update }));
        }}
      />
      <EdgePanel
        id={SILOS_PANEL_ID}
        title="Nível dos silos"
        width={340}
        icon={<SiloIcon />}
        alert={anyRefilling}
      >
        <SiloLevels locations={locations} stateById={stateById} />
      </EdgePanel>
    </React.Fragment>
  );
};

export default SilosPanel;
